<template>
  <div>
    <v-toolbar flat color="white mx-2">
      <v-toolbar-title>リダイレクト管理</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>

      <v-btn color="primary" dark class="mb-2" @click="save()">反映（保存）</v-btn>
    </v-toolbar>

    <v-card class="article_list ma-2" v-bind:style="{ height: height + 'px'}">
      <v-card-title>AppMediaで生成しているランキング用のjsonを取得している</v-card-title>
      <v-card-subtitle class="red--text">【】の中身はAppMediaのサイトでは表示されません</v-card-subtitle>
      
      <!-- 新規登録ダイアログ -->
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="ml-8 mb-2" @click="newItem()" v-on="on">新規追加</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">新規追加</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form_check">
                <v-row>
                  <!-- 名称設定 -->
                  <v-col cols="12" sm="10" md="10">
                    <v-text-field
                      v-model="editedItem.id"
                      label="記事URL (例) /ff7remake/4123425"
                      counter="255"
                      :rules="[required]"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- 名称設定 -->
                  <v-col cols="12" sm="10" md="10">
                    <v-text-field
                      v-model="editedItem.name"
                      label="記事タイトル"
                      counter="255"
                      :rules="[required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="addItem">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <draggable v-model="list" element="ul" :options="{handle:'.drag',animation:200}">
        <v-card v-for="item in list" :key="item.id" class="article_item ma-1" dense>
          <v-container class="pa-1">
            <v-row dense>
              <!-- 名称設定 -->
              <v-col cols="1">
                <span class="drag">
                  <v-icon small>fas fa-bars</v-icon>
                </span>
              </v-col>
              <v-col cols="3">
                <span class="article_url label">{{ item.id }}</span>
              </v-col>
              <v-col cols="6">
                <span class="article_name label">{{ item.name }}</span>
              </v-col>

            <v-col cols="1">
                <span class="delete">
                   <v-btn color="blue darken-1" text @click="edit_item(item)">
                    <v-icon small>fas fa-edit</v-icon>
                  </v-btn>
                </span>
              </v-col>

              <v-col cols="1">
                <span class="delete">
                  <v-btn color="blue darken-1" text @click="delete_item(item)">
                    <v-icon small>fas fa-trash</v-icon>
                  </v-btn>
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </draggable>
    </v-card>
  </div>
</template>



<script>
// Ajax通信ライブラリ
import axios from "axios";

// ドラッグ&ドロップ
import draggable from "vuedraggable";

export default {
  name: "LIST",
  components: {
    draggable
  },
  data() {
    return {
      height: 0,
      dialog: false,

      list: [],
      editedIndex: -1,
      editedItem: {
        id: "", //リンク
        name: "",
        pv: ""
      },

      // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {},

  methods: {
    newItem() {
      this.editedIndex = -1;
      this.editedItem = Object.assign(
        {},
        {
          id: "",
          name: "",
          pv: ""
        }
      );
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },

    //項目の削除
    delete_item(item) {
      const index = this.list.indexOf(item);
      this.list.splice(index, 1);
    },

    //項目の追加
    addItem() {
      var err_flg = false;
      //入力チェック
      if (!this.$refs.form_check.validate()) {
        alert("必須項目を入力してください");
        return;
      }

      this.list.forEach(value => {
        if (value.id == this.editedItem.id) {
          alert("同じURLのデータが存在しています");
          err_flg = true;
          return true;
        }
      });

      if (err_flg) {
        return;
      }

      this.list.unshift(this.editedItem);
      this.dialog = false;
    },
    save: function() {

      axios
        .post(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/save_appmedia_ranking",
          {
            data: this.list,
            category: "ff7remake",
            use: true
          }
        )
        .then(function(response) {
          if (response.data["status"] == "success") {
            alert("成功");
          } else {
            alert("更新失敗・・！");
            console.log(response);
          }
        });
    }
  },

  created: function() {
    axios
      .get(
        "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/appmedia_ranking"
      )
      .then(response => {
        console.log(response);

        const items = [];

        const values = Object.values(response.data.data);
        values.forEach(value => {
          const title = value.name.replace("| AppMedia", "");
          const item = {
            id: value.id,
            name: title,
            pv: value.pv
          };
          items.push(item);
        });

        // //AppMediaのjsonをそのまま呼ぶ時
        // const values = Object.values(response.data);
        // values.forEach(value => {
        //   const title = value[0].replace("| AppMedia", "");
        //   const item = {
        //     id: value[1],
        //     name: title,
        //     pv: value[2]
        //   };
        //   items.push(item);
        // });
        // コンポーネントのデータに代入
        this.list = items;
        // メイン領域の高さ調整(スクロール)
        this.$nextTick(() => {
          this.height = window.innerHeight - 90;
        });
      });
  }
};
</script>

<style scoped>
.article_list {
  overflow-y: scroll;
}

.article_list .v-card {
  counter-increment: count;
}
.article_list .v-card .article_url::before {
  content: counter(count) "位";
  margin: 2px 14px 2px 15px;
  padding: 2px 4px;
  border: 1px solid #aaa;
  border-radius: 4px;
  min-width: 40px;
  text-align: center;
  display: inline-block;
  font-size: 13px;
}

.label {
  margin-right: 6px;
  border-right: 1px solid #ddd;
}

.article_url {
  padding-right: 8px;
}

.article_item {
  max-width: 1200px;
}

.pv {
  display: inline-block;
  min-width: 40px;
  background: #eee;
  text-align: center;
  font-size: 12px;
}

.drag {
  display: block;
  text-align: center;
  padding: 2px;
}
</style>